export enum Permissions {
  LicenseCreate = 'License.Create',
  LicenseRead = 'License.Read',
  LicenseUpdate = 'License.Update',
  LicenseDelete = 'License.Delete',
  PermissionsetCreate = 'Permissionset.Create',
  PermissionsetRead = 'Permissionset.Read',
  PermissionsetUpdate = 'Permissionset.Update',
  PermissionsetDelete = 'Permissionset.Delete',
  PermissionsetImport = 'Permissionset.Import',
  PermissionsetCopy = 'Permissionset.Copy',
  RoleCreate = 'Role.Create',
  RoleRead = 'Role.Read',
  RoleUpdate = 'Role.Update',
  RoleDelete = 'Role.Delete',
  UserCreate = 'User.Create',
  UserImport = 'User.Import',
  UserRead = 'User.Read',
  UserUpdate = 'User.Update',
  UserDelete = 'User.Delete',
  RolePermissionSetUpdate = 'Role.PermissionSet.Update',
  ScopeAdminIS = 'Scope permission: Admin.IS.WebAPI',
  ScopeKpdIS = 'Scope permission: Kpd.IS',
  ScopeReadIS = 'Scope permission: Read.IS.WebAPI',
  ScopeWriteIS = 'Scope permission: Write.IS.WebAPI',
  TenantRead = 'Tenant.Read',
  UserLicenseUpdate = 'User.License.Update',
  UserRoleUpdate = 'User.Role.Update',
  PermissionsetPermissionsUpdate = 'Permissionset.Permissions.Update',
  SystemUserManage = 'SystemUser.Manage',
  UserManage = 'UserManage',
}

export const PERMISSIONS = [
  {
    id: 'f05707a4-490a-43d1-bb40-e57c933e6dcc',
    name: Permissions.LicenseRead,
    description: 'License Read',
  },
  {
    id: '41a72bd9-2578-4ea4-948b-342e3f6b5ac4',
    name: Permissions.PermissionsetCreate,
    description: 'Permissionset Create',
  },
  {
    id: '58e29f3c-1131-443a-9947-8371556618cb',
    name: Permissions.PermissionsetDelete,
    description: 'Permissionset Delete',
  },
  {
    id: '28e84328-4f4a-47b8-9477-64cabbbd709d',
    name: Permissions.PermissionsetRead,
    description: 'Permissionset Read',
  },
  {
    id: 'b23c39d1-723e-469b-ba61-8abb980216bd',
    name: Permissions.PermissionsetUpdate,
    description: 'Permissionset Update',
  },
  {
    id: '6c275759-ee77-4310-93a4-b166e06a3761',
    name: Permissions.PermissionsetImport,
    description: 'Permissionset Import',
  },
  {
    id: '41e0fdab-7509-4d4f-8e69-5e37dd850445',
    name: Permissions.RoleCreate,
    description: 'Role Create',
  },
  {
    id: '38c3e8d2-424a-4798-9763-d4072d6d9b81',
    name: Permissions.RoleDelete,
    description: 'Role Delete',
  },
  {
    id: 'a5e7323c-60a6-4c2d-931f-7ccd37e54e3e',
    name: Permissions.RoleRead,
    description: 'Role Read',
  },
  {
    id: '0f882a9b-6d74-4ae6-9732-dafa7c5ee60a',
    name: Permissions.RoleUpdate,
    description: 'Role Update',
  },
  {
    id: '42d74648-2d7f-48db-a33e-d4fbab46d05e',
    name: Permissions.RolePermissionSetUpdate,
    description: 'Role.PermissionSet Update',
  },
  {
    id: 'c409a39f-bf1a-4b29-b08d-c4b5ef859c5c',
    name: Permissions.ScopeAdminIS,
    description: null,
  },
  {
    id: 'a1307b60-b948-4312-985e-b2c03ae1a69a',
    name: Permissions.ScopeKpdIS,
    description: null,
  },
  {
    id: '1ab854ca-937a-4c25-87dd-2588418e6c60',
    name: Permissions.ScopeReadIS,
    description: null,
  },
  {
    id: '7cab2d29-734c-4849-ba94-3971e9abfb39',
    name: Permissions.ScopeWriteIS,
    description: null,
  },
  {
    id: 'c2aacc0a-e99b-4aec-a008-d8f41b8d74f1',
    name: Permissions.TenantRead,
    description: 'Tenant Read',
  },
  {
    id: '4f15de87-4f73-4841-4172-08d5a45ec81c',
    name: Permissions.UserCreate,
    description: 'User Create',
  },
  {
    id: 'e5607aae-aecf-4efa-831d-4c235fcf88c3',
    name: Permissions.UserDelete,
    description: 'User Delete',
  },
  {
    id: 'e475e7f1-1749-469a-8785-ac06e2fb0356',
    name: Permissions.UserRead,
    description: 'User Read',
  },
  {
    id: 'cda24cc5-d663-416d-8736-415e39d798fb',
    name: Permissions.UserUpdate,
    description: 'User Update',
  },
  {
    id: 'd0b26ca5-b526-4049-a629-f1198e6546f0',
    name: Permissions.UserLicenseUpdate,
    description: 'User.License Update',
  },
  {
    id: '8ffa469b-de6c-4b6f-ad1a-7e6e3ba26371',
    name: Permissions.UserRoleUpdate,
    description: 'User.Role Update',
  },
  {
    id: '59ab31d4-b377-4035-9300-8518ea6027b4',
    name: Permissions.PermissionsetPermissionsUpdate,
    description: 'Permissionset.Permissions.Update',
  },
  {
    id: '25259d93-fa0e-456a-9b9c-d1f446a01e07',
    name: Permissions.PermissionsetCopy,
    description: 'Permissionset.Copy',
  },
  {
    id: '64bf9af8-90df-4697-b43b-4ed0f23f86c8',
    name: Permissions.SystemUserManage,
    description: 'SystemUser.Manage',
  },
  {
    id: '802b630d-4274-4407-9223-895738937242',
    name: Permissions.UserManage,
    description: 'Users.Manage',
  },
  {
    id: 'd04879de-b56b-41f8-92aa-e292764e9837',
    name: Permissions.UserImport,
    description: 'Users.Import',
  },
];
